import { render, staticRenderFns } from "./SudoUser.vue?vue&type=template&id=015a0c94&scoped=true"
import script from "./SudoUser.vue?vue&type=script&lang=js"
export * from "./SudoUser.vue?vue&type=script&lang=js"
import style0 from "./SudoUser.vue?vue&type=style&index=0&id=015a0c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a0c94",
  null
  
)

export default component.exports